import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import {
    FormRevisionSuggestionDTO,
    SquadSuggestionDTO,
    SurveyDTO,
    SurveyFormDataDTO,
    UserSuggestionDTO
} from "@features/bb-formio/dto/form-survey";
import { BooleanFilter, IQueryCommand, QueryCommand, StringFilter } from "@features/filter";
import { NumberArrayFilter } from "@features/filter/classes/number-array-filter";
import { PagedCrudService } from "@features/grid";
import { UserLogin, UserService } from "@main/users";
import { UserHelperService } from "@main/users/user-helper.service";

@Injectable()
export class FormIOSurveyService extends PagedCrudService<SurveyDTO> {
    public readonly url = "api/formio-survey";
    public readonly entityTitle = "Form Surveys";

    constructor(
        http: HttpClient,
        private userService: UserService,
        handlersFactory: HttpResponsesHandlersFactory,
        private _userHelperService: UserHelperService
    ) {
        super(http, handlersFactory);
    }

    queryFilter() : QueryCommand {
        const queryCommand= <QueryCommand>{filters: []};
        queryCommand.filters.push(new NumberArrayFilter("orgIds", this.currentOrganizationIds));
        queryCommand.filters.push(new BooleanFilter("isAdmin", this._userHelperService.isTopAdmin));
        queryCommand.filters.push(new StringFilter("userID", this.userService.currentUser.id));

        return queryCommand;
    }

    extendQueryCommand(queryCommand: IQueryCommand) {
        queryCommand.filters = queryCommand.filters || [];
        queryCommand.filters.push(new NumberArrayFilter("orgIds", this.currentOrganizationIds));
        queryCommand.filters.push(new BooleanFilter("isAdmin", this._userHelperService.isTopAdmin));
        // QueryCommand.filters.push(new StringFilter("userID", this.userService.currentUser.id));
    }

    async getAllUserSuggestions(): Promise<UserSuggestionDTO[]> {
        return this.handle<UserSuggestionDTO[]>(
            this.http.get<UserSuggestionDTO[]>(`${this.url}/get-all-users`, { params: this.constructHttpParams(this.queryFilter()) }),
            this.handlersFactory.getDefault()
        );
    }

    async getAllSquadSuggestions(): Promise<SquadSuggestionDTO[]> {
        return this.handle<SquadSuggestionDTO[]>(
            this.http.get<SquadSuggestionDTO[]>(`${this.url}/get-all-groups`),
            this.handlersFactory.getDefault()
        );
    }

    async getAllFormsSuggestions(): Promise<FormRevisionSuggestionDTO[]> {
        return this.handle<FormRevisionSuggestionDTO[]>(
            this.http.get<FormRevisionSuggestionDTO[]>(`${this.url}/get-all-forms`, {
                params: this.constructHttpParams(this.queryFilter())
            }),
            this.handlersFactory.getDefault()
        );
    }

    async getSurveyData(id: string): Promise<SurveyFormDataDTO[]> {
        return this.handle<SurveyFormDataDTO[]>(
            this.http.get<SurveyFormDataDTO[]>(`${this.url}/get-survey-data/${id}`),
            this.handlersFactory.getDefault()
        );
    }

    async archive(id: string): Promise<void> {
        return this.handle<void>(this.http.post<void>(`${this.url}/archive/${id}`, null), this.handlersFactory.getDefault());
    }

    private get currentOrganizationIds() {
        if(this._userHelperService.isUser) {
            const user = <UserLogin>this.userService.currentUser;
            return user?.userAccesses.map(x => x.organization.id_original);
        } else {
            return [];
        }
    }
}